import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"children"))) && lookupProperty(stack1,"PrintLinkModule")),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":8,"column":7}}})) != null ? stack1 : "")
    + "<div class=\"row\">\n  <div class=\"column small-12 popup-content-text-module__container"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"calcLinks") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":66},"end":{"line":10,"column":114}}})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":13,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":20,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"calcLinks") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":4},"end":{"line":29,"column":11}}})) != null ? stack1 : "")
    + "  </div>\n</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\n  <div class=\"small-12 column popup-content-text-module__print-link\">\n    "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"children"))) && lookupProperty(stack1,"PrintLinkModule")), depth0)) != null ? stack1 : "")
    + "\n  </div>\n</div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return " medium-8 small-centered";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <h2 role=\"heading\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"noHeading")),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":12,"column":23},"end":{"line":12,"column":97}}})) != null ? stack1 : "")
    + " class=\"popup-content-text-module__container__title"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"calcLinks") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":148},"end":{"line":12,"column":225}}})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":12,"column":227},"end":{"line":12,"column":240}}}) : helper))) != null ? stack1 : "")
    + "</h2>\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "aria-level=\"1\"";
},"9":function(container,depth0,helpers,partials,data) {
    return "aria-level=\"2\"";
},"11":function(container,depth0,helpers,partials,data) {
    return " popup-content-text-module__container__title--big-red";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"popup-content-text-module__container__content\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"each","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":6},"end":{"line":18,"column":15}}})) != null ? stack1 : "")
    + "    </div>\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "      <p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"row\">\n        <div class=\"column small-12 popup-content-text-module__container__button-links\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"calcLinks") : depth0),{"name":"each","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":10},"end":{"line":26,"column":19}}})) != null ? stack1 : "")
    + "        </div>\n      </div>\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"copy") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":32,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/popup-content-text-module",
  "version": "1.0.4",
  "id": "popupContentTextModule",
  "containerID": "homeLoansPopupContentTextModule",
  "moduleName": "home-loans-popup-content-text-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "popup-content-text-module",
  "data": {
    "init": "PopupContentTextModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "color",
    "type": "string",
    "description": "This parameter controls the general color scheme of module. The default is blue, but you can also choose red or green.",
    "default": "blue",
    "values": ["red", "green", "blue"]
  }, {
    "name": "noHeading",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter will tell the heading of the module to have an aria-role of 1 if true or 2 if false"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * The PopupContentTextModule Sparta Module.
 * It&#x27;s simple text module
 * @export
 * @class PopupContentTextModule
 * @extends Module
 */
class PopupContentTextModule extends Module {
  /**
   * Initialize the module
   * @method constructor
   * @param {object} options options object
   * @param {object} context context object
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @method init
   * @desc Initialize module
   * @memberof PopupContentTextModule
   * @returns {void}
   */
  init() {
    const disclosures = document.querySelector('#homeMortgageDisclosures');
    if (disclosures) {
      if (window.sparta.language === 'es') {
        disclosures.setAttribute('aria-label', 'nota');
      } else {
        disclosures.setAttribute('aria-label', 'footnote');
      }
    }
  }
}
registerModuleClass({
  moduleClass: PopupContentTextModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { PopupContentTextModule as default, moduleConfig };
